export default class AnalyticsService {
  constructor($http) {
    this.$http = $http;

    this.propel_cm_click_link = "https://tracking.propelmedia.com/?id=1GAEF0G9B26G4E79CF4F&value=0&token={token}";
    this.propel_view_job_details_link = "https://tracking.propelmedia.com/?id=1GAEF0G9B04G104FB3D7&value=0&token={token}";
    this.propel_token = this.getUrlParameter("token") || localStorage["propel_token"] || null;

    if (this.propel_token) {
      this.propel_token = this.propel_token.replace("{", "");
      this.propel_token = this.propel_token.replace("}", "");

      localStorage["propel_token"] = this.propel_token;
    }

    console.log("Loaded Propel Token:", this.propel_token);
  }

  trackViewJobDetailsPage(job) {
    const link = this.propel_view_job_details_link;
    console.log("Propel: Tracking Job Details Page");
    this.submitPropelLink(link);
  }

  trackClickCMJob(job) {
    const link = this.propel_cm_click_link;
    console.log("Propel: Tracking CM job Click");
    this.submitPropelLink(link);
  }

  submitPropelLink(link) {
    if (!this.propel_token) return;

    const url = link.replace("{token}", this.propel_token);

    return this.$http({method: "GET", url})
      .then(() => {})
      .catch(() => {});
  }

  getUrlParameter(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    let regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    let results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }
}

AnalyticsService.$inject = ["$http"];



// WEBPACK FOOTER //
// ./client/app/services/analytics.js